import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  Avatar,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React, { useEffect, useState } from "react";
import { CustomPaginationCommon } from "modules/Users/components";
import { ConfirmModal } from "components";
import { useNavigate, useParams } from "react-router-dom";
import { cousresArray } from "constant/data";
import CommonCardData from "../DiscoverData/CommonCardData";
import { CategoryCommon, FilterCommon, SortDataCommon } from "components";
import { useAuth } from "context/authContext";
import { ContentsService } from "services/ContentsService";

const bgColorBorder = [
  {
    progress: 70,
  },
];
type SelectedValueType =
  | "psychotherapy"
  | "olderAdults"
  | "kids"
  | "healthPsychology"
  | "affirmingAntiRacistTherapy"
  | "neuropsychology"
  | "testing";

const itemsPerPage = 6;
const BestSellingCourseData = ({
  allCoursesData = [],
  setAllCoursesData,
}: any) => {
  const { currentUser, isLoggedIn } = useAuth();
  const theme = useTheme();
  const [selectedValue, setSelectedValue] =
    useState<SelectedValueType>("psychotherapy");
  const [filteredCourses, setFilteredCourses] = useState<any[]>([]);
  const [showAll, setShowAll] = useState(false);
  const [page, setPage] = useState(1);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const navigate = useNavigate();
  const { userType } = useParams();

  const [sortOption, setSortOption] = useState("Best Selling");
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

  const [activeDropdown, setActiveDropdown] = React.useState<number | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [totalItems, setTotalItems] = useState(0); // Total filtered items

  useEffect(() => {
    setLoading(true); // Start loader
    setTimeout(() => {
      let updatedData = [...allCoursesData];

      if (selectedCategory) {
        updatedData = updatedData.filter((course) =>
          course.category?.some(
            (cat: string) =>
              cat.toLowerCase() === selectedCategory.toLowerCase()
          )
        );
      }

      if (selectedFilter) {
        updatedData = updatedData.filter((course) =>
          course.sourceOfKnowledge?.some(
            (source: string) =>
              source.toLowerCase() === selectedFilter.toLowerCase()
          )
        );
      }

      if (sortOption) {
        if (sortOption === "Price low to high") {
          updatedData.sort((a, b) => a.price - b.price);
        } else if (sortOption === "Price high to low") {
          updatedData.sort((a, b) => b.price - a.price);
        } else if (sortOption === "Publication Date") {
          updatedData.sort(
            (a, b) => b.createdAt.toMillis() - a.createdAt.toMillis()
          );
        } else if (sortOption === "Best Selling") {
          updatedData.sort((a, b) => b.purchaseCount - a.purchaseCount);
        }
      }

      setFilteredCourses(updatedData);
      setLoading(false); // Stop loader
    }, 1500); // Simulate a delay (e.g., 1.5s)
  }, [allCoursesData, sortOption, selectedCategory, selectedFilter]);

  const courseData = Array.isArray(filteredCourses)
    ? filteredCourses.filter((content: any) => content.type === "course")
    : [];

  const handleSortChange = (option: any) => setSortOption(option);
  const handleCategoryChange = (category: any) => setSelectedCategory(category);
  const handleFilterChange = (filter: any) => setSelectedFilter(filter);

  const handleClearAll = () => {
    setSelectedCategory(null); // Reset category filter
    setSelectedFilter(null); // Reset source of knowledge filter
    setSortOption("Best Selling"); // Reset sort option to default
    setShowAll(false); // Reset "show all" state
  };

  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const steps: SelectedValueType[] = [
    "psychotherapy",
    "olderAdults",
    "kids",
    "healthPsychology",
    "affirmingAntiRacistTherapy",
    "neuropsychology",
    "testing",
  ];

  const headers: Record<SelectedValueType, string> = {
    psychotherapy: "Psychotherapy",
    olderAdults: "Older Adults",
    kids: "Kids",
    healthPsychology: "Health Psychology",
    affirmingAntiRacistTherapy: "Affirming/Anti-Racist Therapy",
    neuropsychology: "Neuropsychology",
    testing: "Testing",
  };

  const handleSelectionChange = (value: string) => {
    // Find the matching key from the headers object
    const selectedKey = Object.keys(headers).find(
      (key) => headers[key as SelectedValueType] === value
    );
    if (selectedKey) {
      setSelectedValue(selectedKey as SelectedValueType);
    }
  };

  const handleSeeAllClick = () => {
    setShowAll(true);
  };

  // const handlePageChange = (
  //   event: React.ChangeEvent<unknown>,
  //   newPage: number
  // ) => {
  //   setPage(newPage);
  // };
  const handlePageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage + 1); // Convert from 0-based index to 1-based index
  };


  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const itemsPerPage = isMobile ? 4 : 6; // 4 per page on mobile, 6 on desktop

  const paginatedData = courseData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handleLoginConfirm = () => {
    handleConfirmClose();
  };

  const handleDropdownToggle = (dropdownIndex: number) => {
    setActiveDropdown(activeDropdown === dropdownIndex ? null : dropdownIndex);
  };

  const handleNavigateProfile = (userId: any) => {
    const serializableData = JSON.parse(JSON.stringify(allCoursesData));
    navigate(`/profile-view/${userId}`, {
      state: { userContents: serializableData },
    });
  };

  return (
    <Box px={{ xs: 2, md: "66px" }} position={"relative"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={"wrap"}
        alignItems={"center"}
        pt={{ xs: 13, md: "54px" }}
      >
        <Box
          // onClick={handleConfirmOpen}

          fontWeight={700}
          fontSize="33px"
          color="#233F91"
          display={{ md: "flex", xs: "none" }}
          alignItems="center"
          fontFamily={"Atten Round New"}
        >
          Best Selling in Courses
        </Box>
        <Box

          fontWeight={700}
          fontSize="20px"
          color="#233F91"
          display={{ xs: "flex", md: "none" }}
          alignItems="center"
          fontFamily={"Atten Round New"}
        >
          All Courses
        </Box>
        <Box
          display={"flex"}
          gap={1}
          alignItems={"center"}
        >
          <SortDataCommon
            activeDropdown={activeDropdown}
            setActiveDropdown={handleDropdownToggle}
            onSortChange={handleSortChange}
            onClearAll={handleClearAll}
          />

          <CategoryCommon
            activeDropdown={activeDropdown}
            setActiveDropdown={handleDropdownToggle}
            onCategoryChange={handleCategoryChange}
            onClearAll={handleClearAll}
          />
          <FilterCommon
            activeDropdown={activeDropdown}
            setActiveDropdown={handleDropdownToggle}
            onFilterChange={handleFilterChange}
            onClearAll={handleClearAll}
          />
        </Box>
      </Box>


      {
        loading ? (
          <Box display="flex"
            justifyContent="center"
            alignItems="center"
            height="70vh"
            // width="100vw"
            mt={6}>
            <CircularProgress color="primary" />
          </Box>
        ) : paginatedData.length > 0 ? (
          <Grid container spacing={{ xs: 2, sm: 2.5, md: 4 }} pt={{ xs: 2, md: 6 }}>
            {(showAll ? paginatedData : paginatedData.slice(0, 12)).map(
              (item: any, index: any) => (
                <Grid item xs={12} sm={2} md={4} key={index}>

                  <CommonCardData
                    title={item.title}
                    category={item.category}
                    summary={item.summary}
                    author={`${item?.userData?.firstName || ""} ${item?.userData?.lastName || ""
                      }`}
                    createdAt={item.createdAt}
                    sourceOfKnowledge={item.sourceOfKnowledge}
                    type={item.type}
                    price={item.price}
                    coverPhotoUrl={item.coverPhotoUrl}
                    profilePicture={item?.userData?.profileUrl}
                    onClick={() => navigate(`/discover/${item.id}`)}
                    goToProfile={() => handleNavigateProfile(item?.userData?.id)}
                  />
                </Grid>
              )
            )}
          </Grid>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" mt={6}>
            <Typography variant="h6" color="textSecondary">
              No courses match your selected criteria for{" "}
              {selectedCategory
                ? `category "${selectedCategory}"`
                : selectedFilter
                  ? `filter "${selectedFilter}"`
                  : "the current selection"}
              .
            </Typography>
          </Box>
        )
      }

      <ConfirmModal
        title=""
        subtitle="Figma ipsum component variant main layer. Distribute link object effect create editor flatten link. Asset create bullet library figma vector edit move pen slice. Component flows flows team effect pencil main bullet component. Hand export project arrange pencil selection edit background background. Library align."
        cancelText="Register"
        confirmText="Log In"
        isLoading={false}
        onCancel={handleConfirmClose}
        onConfirm={handleLoginConfirm}
        isConfirmModal={confirmOpen}
        warning="Login Required to Continue"
      />
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignContent={"center"}
        m={5}
      >
        <CustomPaginationCommon
          count={courseData.length}
          page={page - 1}
          rowsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
        />
      </Box>

    </Box >
  );
};

export default BestSellingCourseData;

const styleSheet = {
  CateBtn: {
    border: "1.5px solid #233F91",
    color: "#233F91",
    borderRadius: "15px",
    fontSize: "18px",
    fontWeight: 700,
    height: "44px",
    padding: "11px, 13px, 11px, 13px",
  },
};
